import { Component, Children } from 'react';
import propTypes from 'prop-types';

export default class TrackerProvider extends Component {
  constructor(props, context) {
    super(props, context);
    this.tracker = props.tracker;
  }

  getChildContext() {
    return {
      trackEvent: this.tracker.trackEvent
    };
  }

  render() {
    return Children.only(this.props.children);
  }
}

TrackerProvider.propTypes = {
  children: propTypes.element.isRequired,
  tracker: propTypes.shape({})
};

TrackerProvider.childContextTypes = {
  trackEvent: propTypes.func.isRequired
};

TrackerProvider.defaultProps = {
  tracker: {}
};
